import { DataTypeModelKey } from "./dataType.model";

export enum CustomWidgetFullscreenChartMode {
    show = "show",
    hide = "hide",
}

export class CustomWidgetModel {
    id: string;
    name?: string;
    projectDeviceId: string;
    primaryMetrics: DataTypeModelKey[];
    secondaryMetrics: DataTypeModelKey[];
    chartMetric?: DataTypeModelKey | null;
    fullscreenChartMode: CustomWidgetFullscreenChartMode;
}
